import { render, staticRenderFns } from "./productsTable.vue?vue&type=template&id=42e475e0&scoped=true"
import script from "./productsTable.vue?vue&type=script&lang=js"
export * from "./productsTable.vue?vue&type=script&lang=js"
import style0 from "./productsTable.vue?vue&type=style&index=0&id=42e475e0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42e475e0",
  null
  
)

export default component.exports